module.exports = __webpack_public_path__ + "img/ddb3409.jpg";